import { useEffect, useState } from "react";
import { localeAsLanguageKey, locales } from "../../utils/locales";
import { getFilePropsFromResponse, showFile } from "components/filepreview/FilePreview";
import { request } from "components/utils/Request2";
import { Language } from "imports/Utils";
import { Button } from "@cofano/cck";
import { useCoastguard } from "@cofano/coastguard2-frontend-client";
import { saveAs } from "file-saver";
import { intl } from "LocaleWrapper";
import { Box, ToggleButton, ToggleButtonGroup } from "@mui/material";

const PdfContainer = ({ entityType, entityId, ...props }) => {

	const { instance } = useCoastguard();

	const [ exportLoading, setExportLoading ] = useState(false);
	const [ pdfLanguage, setPdfLanguage ] = useState(locales.EN);
	const [ { file, type }, setFile ] = useState({});

	const getFile = () => {

		switch (entityType) {
			case entityWithDocument.CONTRACT:
				request({
					url: `finance/contracts/${entityId}/export?preview=true${pdfLanguage ? `&language=${pdfLanguage}` : ""}`,
					method: "GET",
				}).then(response => setFile(getFilePropsFromResponse(response)));
				break;
			case entityWithDocument.CARGO_ACTION_LOP:
				request({
					url: `protestletter/${entityId}/export?preview=true${pdfLanguage ? `&language=${pdfLanguage}` : ""}`,
					method: "GET",
				}).then(response => setFile(getFilePropsFromResponse(response)));
				break;

			default:
				break;
		}

	};

	const handleOnDownload = () => {

		const url = resolveDocumentUrl(entityType, entityId, pdfLanguage);

		setExportLoading(true);

		instance.fetchBlob(url, {
			method: "GET",
		}).then(async (blob) => {
			saveAs(blob, `${entityType}.pdf`);
		}).finally(() => {
			setExportLoading(false);
		});
	};

	useEffect(() => {
		getFile();
	}, [ pdfLanguage ]);

	return (
		<div>
			<Box sx={{ mb: 2 }}>
				<Box sx={{ alignItems: "center", display: "flex", justifyContent: "space-between" }}>
					<Box sx={{ display: "flex", gap: 1 }}>
						<ToggleButtonGroup
							color="primary"
							value={pdfLanguage}
							exclusive
							onChange={(event, value) => setPdfLanguage(value)}
							size="small">
							{Object.values(locales).map((locale) => (
								<ToggleButton key={locale} value={locale}>
									{localeAsLanguageKey(locale)}
								</ToggleButton>
							))}
						</ToggleButtonGroup>
					</Box>

					<Button
						onClick={() => handleOnDownload()}
						loading={exportLoading}
						size="small"
						variant="outlined">
						{Language("DOWNLOAD")}
					</Button>
				</Box>
			</Box>

			<div>
				{showFile(file, type)}
			</div>
		</div>
	);
};

export const openSidebarWithPdf = (entityType, entityId, layout) => {
	layout.setDrawerSettings({
		open: true,
		title: intl.formatMessage({ id: "PREVIEW_PDF" }),
		content: (
			<Box p={2}>
				<PdfContainer entityType={entityType} entityId={entityId} />
			</Box>
		),
		size: "large",
		variant: "overlay",
	});
};

const resolveDocumentUrl = (type, id, language) => {
	let url;
	switch (type) {
		case entityWithDocument.CONTRACT:
			url = `/finance/contracts/${id}/export`;
			break;
		case entityWithDocument.CARGO_ACTION_LOP:
			url = `/protestletter/${id}/export`;
			break;

		default:
			break;
	}

	return `${url}${language ? `?language=${language}` : ""}`;
};

export const entityWithDocument = {
	CONTRACT: "contract",
	CARGO_ACTION_LOP: "cargoAction_LOP",
};

export default PdfContainer;

